import environment from '@environment/'
import api from '@api/api'

const endpoints = environment.managerApi.endpoints

const getAddress = async zipCode => {
  return await api.get(endpoints.address.get.replace(':zipCode', zipCode))
}

export { getAddress }
